import React from "react";
import { Form } from "antd";
import { FormInstance } from "antd/lib/form/Form";

import { SelectWithSpinAndCustomMaxTag } from "@src/components/select/SelectWithCustomMaxTag";
import { IntelligenceFormFieldsEnum } from "../enum";

export const PlatformInput: React.FC<{
  form: FormInstance<any>;
}> = ({ form }) => {
  const productCodeWatch = Form.useWatch(IntelligenceFormFieldsEnum.PRODUCT_CODE, form);
  const options = React.useMemo(() => {
    return [
      {
        label: "Android",
        value: productCodeWatch + "a",
      },
      {
        label: "IOS",
        value: productCodeWatch + "i",
      },
    ];
  }, [productCodeWatch]);

  // React.useEffect(() => {
  //   if (options.length > 0) {
  //     form.setFieldValue(
  //       IntelligenceFormFieldsEnum.PLATFORM,
  //       options.map((opt) => opt.value),
  //     );
  //   }
  // }, [form, options]);
  return (
    <Form.Item
      name={IntelligenceFormFieldsEnum.PLATFORM}
      label={""}
      className="w-[200px] pb-2"
      rules={[
        {
          required: true,
          message: "Please select platform",
        },
      ]}
    >
      <SelectWithSpinAndCustomMaxTag
        mode="multiple"
        disabled={!productCodeWatch}
        placeholder="Platform"
        options={options}
      />
    </Form.Item>
  );
};
